/* =====================================================================
   UUGI Event Detail Pages — shared interactions
   Used by event-offline-details.html and event-online-recording.html
   ===================================================================== */

$(function () {

  /* ---------- Navbar scroll state ---------- */
  var $nav = $('#nav');
  function onScroll() {
    if ($(window).scrollTop() > 30) $nav.addClass('is-scrolled');
    else $nav.removeClass('is-scrolled');
  }
  $(window).on('scroll', onScroll);
  onScroll();


  /* ---------- Smooth anchor scroll ---------- */
  $('a[href^="#"]').on('click', function (e) {
    var t = $(this).attr('href');
    if (t.length < 2) return;
    var $tgt = $(t);
    if (!$tgt.length) return;
    e.preventDefault();
    $('html, body').animate({ scrollTop: $tgt.offset().top - 70 }, 700, 'swing');
  });


  /* ---------- Scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $('.reveal').addClass('is-visible');
  }


  /* ---------- Mobile nav drawer: see js/nav.js ---------- */


  /* ---------- Schedule slot hover focus ---------- */
  $('.ed-slot').on('mouseenter', function () {
    $(this).addClass('is-hover');
  }).on('mouseleave', function () {
    $(this).removeClass('is-hover');
  });


  /* ---------- YouTube recording player ---------- */
  // Loads the embed only on interaction (autoplay), optionally seeking to a
  // chapter start. #edPlayer's data-yt holds the raw YouTube URL entered in the
  // back office (e.g. https://www.youtube.com/watch?v=QJXo_I2PsV0); the video id
  // is extracted at runtime so any standard YouTube URL form just works.
  function timeToSeconds(t) {
    var parts = String(t || '0').split(':').map(Number);
    if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
    if (parts.length === 2) return parts[0] * 60 + parts[1];
    return parts[0] || 0;
  }
  // Accepts a full YouTube URL (watch?v=, youtu.be/, /embed/, /shorts/, /live/, /v/)
  // or a bare 11-char id, and returns just the video id ('' when none is found).
  function youTubeId(input) {
    if (!input) return '';
    var value = String(input).trim();
    if (/^[A-Za-z0-9_-]{11}$/.test(value)) return value;
    var match = value.match(/(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/|v\/))([A-Za-z0-9_-]{11})/);
    return match ? match[1] : '';
  }
  function loadEdVideo(startSec) {
    var player = document.getElementById('edPlayer');
    if (!player) return;
    var videoId = youTubeId(player.getAttribute('data-yt'));
    if (!videoId) return;
    var src = 'https://www.youtube-nocookie.com/embed/' + videoId +
      '?autoplay=1&rel=0&modestbranding=1&playsinline=1' + (startSec ? '&start=' + startSec : '');
    var iframe = player.querySelector('.ed-player__iframe');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.className = 'ed-player__iframe';
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', 'UmbraShow webinar recording');
      player.appendChild(iframe);
    }
    iframe.src = src;
    player.classList.add('is-playing');
  }
  $('.ed-player__play').on('click', function () { loadEdVideo(0); });


  /* ---------- Chapter clicks (online page) ---------- */
  var $chapters = $('#edChapters .ed-chap');
  var $active = $('#ed-active-chapter');
  $chapters.on('click', function () {
    var $btn = $(this);
    $chapters.removeClass('is-active');
    $btn.addClass('is-active');

    var time = $btn.attr('data-time') || '00:00';
    var label = $btn.attr('data-label') || '';

    if ($active.length) {
      $active.html('Currently playing · <strong>' + time + ' — ' + label + '</strong>');
      $active.css({ opacity: 0.4 }).animate({ opacity: 1 }, 350);
    }

    // Load (or seek) the recording to this chapter's start time
    loadEdVideo(timeToSeconds(time));

    // Scroll up to player
    var $player = $('#edPlayer');
    if ($player.length) {
      $('html, body').animate({ scrollTop: $player.offset().top - 100 }, 550, 'swing');
      $player.addClass('ed-player--pulse');
      setTimeout(function () { $player.removeClass('ed-player--pulse'); }, 900);
    }
  });


  /* ---------- Contact form feedback ---------- */
  $('#edForm').on('submit', function (e) {
    e.preventDefault();
    var $btn = $(this).find('button[type="submit"] .jbtn__label');
    var orig = $btn.text();
    $btn.text('Sent ✓ — धन्यवाद');
    setTimeout(function () {
      $btn.text(orig);
      $('#edForm')[0].reset();
    }, 2600);
  });


  /* ---------- Footer newsletter ---------- */
  $('.footer__news').on('submit', function (e) {
    e.preventDefault();
    var $btn = $(this).find('button');
    var orig = $btn.text();
    $btn.text('Thanks ✓');
    $(this).find('input').val('');
    setTimeout(function () { $btn.text(orig); }, 2400);
  });


  /* ---------- Subtle hero parallax ---------- */
  $(window).on('mousemove', function (e) {
    var x = e.clientX / window.innerWidth - 0.5;
    var y = e.clientY / window.innerHeight - 0.5;
    $('.ed-hero__chakra--tr').css('transform',
      'translate(' + (x * 16) + 'px, ' + (y * 16) + 'px)');
    $('.ed-hero__chakra--bl').css('transform',
      'translate(' + (x * -10) + 'px, ' + (y * -10) + 'px)');
  });


  /* ---------- Gallery lightbox (popup zoom & view) ---------- */
  (function () {
    var photos = Array.prototype.slice.call(document.querySelectorAll('.ed-gallery figure'));
    if (!photos.length) return;

    var ICX = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    var ICL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
    var ICR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';
    var ICZ = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3M11 8v6M8 11h6"/></svg>';

    var glb = document.createElement('div');
    glb.className = 'ed-glb';
    glb.id = 'edGalleryLightbox';
    glb.setAttribute('role', 'dialog');
    glb.setAttribute('aria-modal', 'true');
    glb.setAttribute('aria-label', 'Photo viewer');
    glb.setAttribute('aria-hidden', 'true');
    glb.innerHTML =
      '<button type="button" class="ed-glb__close" aria-label="Close photo viewer">' + ICX + '</button>' +
      '<button type="button" class="ed-glb__btn ed-glb__prev" aria-label="Previous photo">' + ICL + '</button>' +
      '<button type="button" class="ed-glb__btn ed-glb__next" aria-label="Next photo">' + ICR + '</button>' +
      '<figure class="ed-glb__fig"><img class="ed-glb__img" alt="" /><figcaption class="ed-glb__cap"></figcaption></figure>';
    document.body.appendChild(glb);

    var imgEl = glb.querySelector('.ed-glb__img');
    var capEl = glb.querySelector('.ed-glb__cap');
    var btnClose = glb.querySelector('.ed-glb__close');
    var btnPrev = glb.querySelector('.ed-glb__prev');
    var btnNext = glb.querySelector('.ed-glb__next');
    var cur = 0, lastFocus = null;

    function bigSrc(src) { return src.replace(/([?&]w=)\d+/, '$1' + 1600); }
    function show(i) {
      cur = (i + photos.length) % photos.length;
      var fig = photos[cur];
      var img = fig.querySelector('img');
      var cap = fig.querySelector('figcaption');
      imgEl.src = bigSrc(img.getAttribute('src'));
      imgEl.alt = img.getAttribute('alt') || '';
      capEl.textContent = cap ? cap.textContent : '';
    }
    function open(i) {
      lastFocus = document.activeElement;
      show(i);
      glb.classList.add('is-open');
      glb.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ed-glb-open');
      setTimeout(function () { btnClose.focus(); }, 60);
    }
    function close() {
      glb.classList.remove('is-open');
      glb.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ed-glb-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    photos.forEach(function (fig, i) {
      fig.setAttribute('role', 'button');
      fig.setAttribute('tabindex', '0');
      fig.setAttribute('aria-label', 'View photo full screen');
      var zoom = document.createElement('span');
      zoom.className = 'ed-gphoto__zoom';
      zoom.setAttribute('aria-hidden', 'true');
      zoom.innerHTML = ICZ;
      fig.appendChild(zoom);
      fig.addEventListener('click', function () { open(i); });
      fig.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(i); }
      });
    });
    btnClose.addEventListener('click', close);
    btnPrev.addEventListener('click', function () { show(cur - 1); });
    btnNext.addEventListener('click', function () { show(cur + 1); });
    glb.addEventListener('click', function (e) { if (e.target === glb || e.target.classList.contains('ed-glb__fig')) close(); });
    document.addEventListener('keydown', function (e) {
      if (!glb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(cur - 1);
      else if (e.key === 'ArrowRight') show(cur + 1);
    });
  })();

});
